import React from "react";
const { Component } = React;
import $ from "jquery";
import { Decimal } from "decimal.js";
import { formatPrice } from "./Format";

export default class ProductAddons extends Component {
    state = {
        initialized: false,
        selectedRecommendedAddons: [],
        selectedAddons: [],
    };

    componentDidMount() {
        this.setState(
            Object.assign({ initialized: true }, pottsalat_product_addons)
        );
    }

    componentDidUpdate() {
        this.updatePrice();
    }

    updatePrice() {
        let price = Decimal(this.state.baseProductPrice);
        for (let i = 0; i < this.state.addonsRecommended.length; i++) {
            if (
                this.state.selectedRecommendedAddons.includes(
                    this.state.addonsRecommended[i].id
                )
            ) {
                price = price.plus(
                    Decimal(this.state.addonsRecommended[i].price)
                );
            }
        }
        for (let i = 0; i < this.state.addons.length; i++) {
            if (this.state.selectedAddons.includes(this.state.addons[i].id)) {
                price = price.plus(Decimal(this.state.addons[i].price));
            }
        }
        $("#main .summary .woocommerce-Price-amount").text(formatPrice(price));
    }

    triggerRecommendedAddonProduct(product_id) {
        let selected = [...this.state.selectedRecommendedAddons];
        if (selected.includes(product_id)) {
            selected = selected.filter((item) => item !== product_id);
        } else {
            selected.push(product_id);
        }
        this.setState({
            selectedRecommendedAddons: selected,
        });
    }

    triggerAddonProduct(product_id) {
        let selected = [...this.state.selectedAddons];
        if (selected.includes(product_id)) {
            selected = selected.filter((item) => item !== product_id);
        } else {
            selected.push(product_id);
        }
        this.setState({
            selectedAddons: selected,
        });
    }

    render() {
        if (!this.state.initialized) return <div>...</div>;
        return (
            <div>
                {this.renderDressings()}
                {this.renderRecommendedAddons()}
                {this.renderAddons()}
                {this.renderBreadAddons()}
            </div>
        );
    }

    renderDressings() {
        if (!this.state.dressings.length) return;
        return (
            <div>
                <h4>Dressing wählen:</h4>
                {this.renderDressingSelect()}
            </div>
        );
    }

    renderDressingSelect() {
        let options = [];
        let recommended = null;
        for (let i = 0; i < this.state.dressings.length; i++) {
            if (this.state.dressings[i].recommended)
                recommended = this.state.dressings[i].id;
            options.push(
                <option
                    value={this.state.dressings[i].id}
                    key={`product-${this.state.dressings[i].id}`}
                >
                    {this.state.dressings[i].title +
                        (this.state.dressings[i].recommended
                            ? " (empfohlen)"
                            : "")}
                </option>
            );
        }
        return (
            <select id="dressing" name="dressing" defaultValue={recommended}>
                {options}
            </select>
        );
    }

    renderRecommendedAddons() {
        if (!this.state.addonsRecommended.length) return;
        return (
            <div>
                <h4>Wir empfehlen</h4>
                {this.renderRecommendedAddonProducts()}
            </div>
        );
    }

    renderRecommendedAddonProducts() {
        let products = [];
        for (let i = 0; i < this.state.addonsRecommended.length; i++) {
            products.push(
                this.renderRecommendedAddonProduct(
                    this.state.addonsRecommended[i]
                )
            );
        }
        return products;
    }

    renderRecommendedAddonProduct(product_data) {
        return (
            <div
                key={`product-${product_data.id}`}
                className={`product-addon-box product-addon-box-recommended${
                    this.state.selectedRecommendedAddons.includes(
                        product_data.id
                    )
                        ? " active"
                        : ""
                }`}
                onClick={this.triggerRecommendedAddonProduct.bind(
                    this,
                    product_data.id
                )}
            >
                <img src={product_data.image} alt={product_data.title} />
                {product_data.title}
                <br />
                <small>{formatPrice(product_data.price)}</small>
            </div>
        );
    }

    renderAddons() {
        if (!this.state.addons.length) return;
        return (
            <div>
                <h4>Extras wählen:</h4>
                {this.renderAddonProducts()}
                <input
                    type="hidden"
                    id="products"
                    name="products"
                    value={[
                        ...this.state.selectedAddons,
                        ...this.state.selectedRecommendedAddons,
                    ].join(",")}
                />
            </div>
        );
    }

    renderAddonProducts() {
        let products = [];
        for (let i = 0; i < this.state.addons.length; i++) {
            products.push(this.renderAddonProduct(this.state.addons[i]));
        }
        return products;
    }

    renderAddonProduct(product_data) {
        let checked = {};
        if (this.state.selectedAddons.includes(product_data.id)) {
            checked.checked = "checked";
        }
        return (
            <div
                key={`product-${product_data.id}`}
                className={`product-addon-box ${
                    this.state.selectedAddons.includes(product_data.id)
                        ? " active"
                        : ""
                }`}
                onClick={this.triggerAddonProduct.bind(this, product_data.id)}
            >
                <input type="checkbox" {...checked} />
                <span>
                    {product_data.title}: {formatPrice(product_data.price)}
                </span>
            </div>
        );
    }

    renderBreadAddons() {
        if (!this.state.addonProducts.length) return;
        return (
            <div>
                <h4>Brot & Dip wählen:</h4>
                {this.renderBreadAddonProducts()}
            </div>
        );
    }

    renderBreadAddonProducts() {
        let products = [];
        for (let i = 0; i < this.state.addonProducts.length; i++) {
            products.push(
                this.renderBreadAddonProduct(this.state.addonProducts[i])
            );
        }
        return products;
    }

    renderBreadAddonProduct(product_data) {
        let checked = {};
        if (this.state.selectedAddons.includes(product_data.id)) {
            checked.checked = "checked";
        }
        return (
            <div
                key={`product-${product_data.id}`}
                className={`product-addon-box ${
                    this.state.selectedAddons.includes(product_data.id)
                        ? " active"
                        : ""
                }`}
                onClick={this.triggerAddonProduct.bind(this, product_data.id)}
            >
                <input type="checkbox" {...checked} />
                <span>
                    {product_data.title}: {formatPrice(product_data.price)}
                </span>
            </div>
        );
    }
}
